var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHugeiconsJobSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6758 28.0006H12.8065C8.0265 28.0006 5.63717 28.0006 4.15184 26.4873C2.6665 24.974 2.6665 22.538 2.6665 17.6673C2.6665 12.7967 2.6665 10.3607 4.15184 8.84732C5.63717 7.33398 8.0265 7.33398 12.8065 7.33398H17.8772C22.6572 7.33398 25.0478 7.33398 26.5332 8.84732C27.6758 10.0113 27.9385 11.722 27.9998 14.6673",
    stroke: "white",
    strokeOpacity: 0.48,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.689 26.6977L29.333 29.3337M21.333 7.33366L21.1997 6.92033C20.5397 4.86699 20.2103 3.84033 19.425 3.25366C18.6383 2.66699 17.5957 2.66699 15.5063 2.66699H15.1557C13.069 2.66699 12.025 2.66699 11.2397 3.25366C10.453 3.84033 10.1237 4.86699 9.46367 6.92033L9.33301 7.33366M28.0703 23.3683C28.0809 22.7442 27.967 22.1242 27.7354 21.5445C27.5038 20.9648 27.1592 20.4371 26.7215 19.992C26.2838 19.5469 25.7619 19.1934 25.1862 18.9521C24.6105 18.7108 23.9926 18.5865 23.3683 18.5865C22.7441 18.5865 22.1261 18.7108 21.5504 18.9521C20.9747 19.1934 20.4528 19.5469 20.0152 19.992C19.5775 20.4371 19.2328 20.9648 19.0013 21.5445C18.7697 22.1242 18.6558 22.7442 18.6663 23.3683C18.6871 24.6017 19.1916 25.7775 20.0712 26.6423C20.9507 27.5072 22.1348 27.9918 23.3683 27.9918C24.6019 27.9918 25.786 27.5072 26.6655 26.6423C27.5451 25.7775 28.0496 24.6017 28.0703 23.3683Z",
    stroke: "white",
    strokeOpacity: 0.48,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHugeiconsJobSearch);
export default __webpack_public_path__ + "static/media/hugeicons_job-search.a822ce2247366c2deb08562043dd64a7.svg";
export { ForwardRef as ReactComponent };